<template>
  <div>
    <p class="capitalise">{{ $t("ui.teamAttributes.selectYourTeam") }}:</p>

    <div
      v-for="team in possibleTeams.sort()" 
      :key="team"
      class="team-select capitalise"
      @click="selectTeam(team)">
        {{ team }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    possibleTeams: Array,
  },

  methods: {
    selectTeam(team) {
      this.$emit("update:selectedTeam", team);
    }
  }
}
</script>

<style scoped>
.team-select {
  font-size: 0.8rem;
  padding: 4px 16px;
  min-width: 15vw;
}

.team-select:nth-child(even) {
  background: #181818;
}

.team-select:hover {
  background: #242424;
  cursor: pointer;
}

.capitalise {
  text-transform: capitalize;
}
</style>
